// frontend/src/utils/departments.js
//
// Helper compartido para leer/escribir la lista de departamentos rápidos.
// Antes, cada componente (FileTable, UploadModal, ConsultModal) leía
// 'promofiles_quick_departments' directamente con su propio parsing,
// su propio fallback y a veces extraía `.label`, a veces `.value`.
// Eso provocaba inconsistencias sutiles.
//
// LIMITACIÓN ACTUAL: persistencia en localStorage → cada navegador tiene
// su propia lista. TODO: migrar a un modelo en backend.

const STORAGE_KEY = 'promofiles_quick_departments';

const DEFAULT_DEPARTMENTS = [
  { label: 'Ventas', value: 'Ventas' },
  { label: 'Compras', value: 'Compras' },
  { label: 'Gestoría', value: 'Gestoria' },
  { label: 'General', value: 'General' },
];

/**
 * Devuelve la lista de departamentos como [{ label, value }].
 * Si no hay nada guardado, devuelve los valores por defecto.
 */
export function loadDepartments() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return [...DEFAULT_DEPARTMENTS];
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every(d => d && d.value)) {
      return parsed;
    }
  } catch (_) { /* ignorar JSON malformado */ }
  return [...DEFAULT_DEPARTMENTS];
}

/**
 * Devuelve solo los `value` de los departamentos. Útil para <select>
 * cuando solo necesitas el código (que es lo que se guarda en BD).
 */
export function loadDepartmentValues() {
  return loadDepartments().map(d => d.value);
}

/**
 * Persiste la lista de departamentos.
 */
export function saveDepartments(departments) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(departments));
}
